<template>
  <div class="b2b-grid__stock-watch lg:justify-center">
    <button
      v-on:click="updateEtaWatchState(etaItem)"
      class="b2b-grid__stock-watch__indicator enabled"
      :class="[
        { 'text-success' : etaItem.etaWatch === true },
      ]">
      <i class="b2b-grid__stock-watch__icon material-icons">
        {{ etaItem.etaWatch === true ? 'visibility' : 'visibility_off'}}</i>
      <span
        :class="`b2b-grid__stock-watch__label b2b-grid__stock-watch__label font-medium text-sm`"
      >{{ getBaseProperty('watch') }}</span>
    </button>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    baseProperties: Array,
    etaItem: Object,
    token: String,
  },
  methods: {
    // NOTE: The endpoint and parameters were not provided in the AC, but Kiran
    // provided the gist below, and also existing axios code in 
    // OrderItemDetails.vue was used as reference.
    // https://gist.github.com/kmanur/891ca4a2de74b87d6ecbfa1dc4878fdd
    updateEtaWatchState(etaItem) {
      if (etaItem.etaWatch) {
        axios
          .delete(`/my-account/etawatch/${etaItem.etaWatchId}?CSRFToken=${this.token}`)
          .then(({data: {data: responseData}}) => {
            if (responseData.success) {
              etaItem.etaWatch = false;
              etaItem.etaWatchId = null;
            }
          })
          .catch((error) => console.log(error));
      } else {
        // This scenario is for when user reclicks the ETA toggle button before
        // refreshing the page, hence since the target ETA watch has already been deleted
        // it needs to be re-posted
        const {sku, warehouse, orderLineNumber, orderNumber, orderType, orderCompany} = etaItem;
        const payload = {
          sku,
          warehouse,
          orderLineNumber,
          orderNumber,
          orderType,
          orderCompany,
        };
        axios
          .post(`/my-account/etawatch?CSRFToken=${this.token}`, payload)
          .then(({data: {data: responseData}}) => {
            if (responseData.success) {
              etaItem.etaWatch = true;
              etaItem.etaWatchId = responseData.id;
            }
          })
          .catch((error) => console.log(error));
      }
    },
  },
};
</script>
